type MakeRetinaSrcSetParams = {
    mobileMaxWidth: number;
    desktopMaxWidth: number;
    aspectRatio?: number;
    baseUrl: string;
};

export function getHeightFromWidthAndAspectRatio(
    width: number,
    aspectRatio?: number
) {
    if (!aspectRatio) {
        return -1;
    }

    return Math.round(width / aspectRatio);
}

export function makeImageResizeUrl(
    baseUrl: string,
    width = 25,
    height = 19,
    srcSet?: boolean,
    srcSetPixelDensity?: number
) {
    const resizeUrl = baseUrl
        .replace(/^http:\/\//, "//")
        .replace(/^\/\//, "https://")
        .replace(
            /(\/)(-*\d+x-*\d+)(.\w+)$/,
            `$1${width}x${height}$3${
                srcSet
                    ? ` ${
                          srcSetPixelDensity
                              ? `${srcSetPixelDensity}x`
                              : `${width}w`
                      }`
                    : ""
            }`
        );

    return `${resizeUrl}?cx=0&cy=0`;
}

export function makeRetinaSrcsets({
    mobileMaxWidth,
    desktopMaxWidth,
    aspectRatio,
    baseUrl,
}: MakeRetinaSrcSetParams) {
    return {
        mobile: [1, 2]
            .map((pixelDensity) => {
                const w = mobileMaxWidth * pixelDensity;
                const h = getHeightFromWidthAndAspectRatio(w, aspectRatio);

                return makeImageResizeUrl(baseUrl, w, h, true, pixelDensity);
            })
            .join(", "),
        desktop: [1, 2]
            .map((pixelDensity) => {
                const w = desktopMaxWidth * pixelDensity;
                const h = getHeightFromWidthAndAspectRatio(w, aspectRatio);

                return makeImageResizeUrl(baseUrl, w, h, true, pixelDensity);
            })
            .join(", "),
    };
}
